import React, { Suspense, useEffect, useRef, useState } from "react";

import "assets/css/home-modern.css";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";

// sections for this page
import Stats from "./index-sections/Stats.js";
import AboutUs from "./index-sections/AboutUs.js";
import WhyMore from "./index-sections/WhyMore.js";
import MembershipPlans from "./index-sections/MembershipPlans.js";
import ContactUs from "./index-sections/ContactUs.js";

// Gallery is image-heavy — code-split it and only mount when scrolled near,
// so its bundle and photos never load during initial page start-up.
const Carousel = React.lazy(() => import("./index-sections/Gallary.js"));

function GalleryLoader() {
  return (
    <div className="hm-gal-loader">
      <span className="hm-spinner" aria-hidden="true" />
    </div>
  );
}

function LazyGallery() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || visible) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "400px 0px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [visible]);

  return (
    <div ref={ref}>
      {visible ? (
        <Suspense fallback={<GalleryLoader />}>
          <Carousel />
        </Suspense>
      ) : (
        <GalleryLoader />
      )}
    </div>
  );
}

function Index() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });

  React.useEffect(() => {
    const els = document.querySelectorAll(".hm-reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("hm-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el, i) => {
      el.style.transitionDelay = (i % 3) * 80 + "ms";
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <IndexHeader />
        <div className="main hm">
          <Stats />
          <AboutUs />
          <WhyMore />
          <LazyGallery />
          <MembershipPlans />
          <ContactUs />
        </div>
        <DarkFooter />
      </div>
    </>
  );
}

export default Index;
